import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useRestaurant } from '../../contexts/RestaurantContext';
import { Building, Info, Users, Shield } from 'lucide-react';

const RestaurantInfo: React.FC = () => {
  const { user } = useAuth();
  const { restaurant } = useRestaurant();

  if (!user) return null;

  return (
    <div className="card p-4 mb-6 bg-blue-50 border-blue-200">
      <div className="flex items-start space-x-3">
        <Info className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0" />
        <div className="flex-1">
          <h3 className="text-sm font-medium text-blue-900 mb-2">
            Filtros de Reservas por Restaurante
          </h3>
          
          {user.tipo === 'admin_global' ? (
            <div className="space-y-2 text-sm text-blue-800">
              <div className="flex items-center space-x-2">
                <Shield className="h-4 w-4" />
                <span><strong>Administrador Global:</strong> Pode ver reservas de todos os restaurantes</span>
              </div>
              <p className="ml-6">
                Use o filtro "Restaurante" acima para ver reservas de um restaurante específico, 
                ou deixe em "Todos os restaurantes" para ver todas as reservas do sistema.
              </p>
            </div>
          ) : (
            <div className="space-y-2 text-sm text-blue-800">
              <div className="flex items-center space-x-2">
                <Building className="h-4 w-4" />
                <span><strong>Restaurante Atual:</strong> {restaurant?.nome}</span>
              </div>
              <div className="flex items-center space-x-2">
                <Users className="h-4 w-4" />
                <span><strong>Permissão:</strong> {
                  user.tipo === 'manager_restaurante' ? 'Gestor' : 
                  user.tipo === 'staff' ? 'Staff' : user.tipo
                }</span>
              </div>
              <p className="ml-6">
                {user.tipo === 'staff' && ' Como Staff, pode confirmar e cancelar reservas.'}
                {user.tipo === 'manager_restaurante' && ' Como Gestor, tem acesso total às reservas e configurações.'}
              </p>
            </div>
          )}
          
         
        </div>
      </div>
    </div>
  );
};

export default RestaurantInfo;
